import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=e952d60a&scoped=true&"
import script from "./StatusChip.vue?vue&type=script&lang=js&"
export * from "./StatusChip.vue?vue&type=script&lang=js&"
import style0 from "./StatusChip.vue?vue&type=style&index=0&id=e952d60a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e952d60a",
  null
  
)

/* custom blocks */
import block0 from "./StatusChip.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e952d60a')) {
      api.createRecord('e952d60a', component.options)
    } else {
      api.reload('e952d60a', component.options)
    }
    module.hot.accept("./StatusChip.vue?vue&type=template&id=e952d60a&scoped=true&", function () {
      api.rerender('e952d60a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/StatusChip.vue"
export default component.exports